import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyCreaAction } from "../../actions/company.actions";
import { Card, Col } from "antd";
import CreaList from "../../components/List/Crea.list";
import Localize from "../../libs/localization";
import GatedTableEmptyState from "../../design-library/GatedTableEmptyState/GatedTableEmptyState.component";

const CompanyCrea = (props) => {
  const { companyId, hasAccess = true } = props;

  const crea = useSelector((state) => state.company.crea);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasAccess) searchRequest();
  }, [companyId, hasAccess]);

  const searchRequest = () => {
    dispatch(getCompanyCreaAction({ id: companyId }));
  };

  if (!hasAccess) {
    return (
      <Col span={24} className="animation fadein-right slow">
        <Card
          bordered={false}
          className="companyPage__body-card companyPage__body-card--custom customCard"
        >
          <GatedTableEmptyState
            message={Localize(
              "PAGES.COMPANIES.DETAIL.SECTIONS.CREATIVITY_GATED_MESSAGE",
            )}
          />
        </Card>
      </Col>
    );
  }

  return (
    <Col span={24} className="animation fadein-right slow">
      <CreaList data={crea?.data} loading={crea?.loading} />
    </Col>
  );
};

export default CompanyCrea;
